export const INCREMENT_HOME_COMPONENT_COUNTER =
  "INCREMENT_HOME_COMPONENT_COUNTER";
export const DECREMENT_HOME_COMPONENT_COUNTER =
  "DECREMENT_HOME_COMPONENT_COUNTER";
export const SET_HOME_COMPONENT_COUNTER =
  "SET_HOME_COMPONENT_COUNTER";
export const DISABLE_SCROLL = "DISABLE_SCROLL";
export const ENABLE_SCROLL = "ENABLE_SCROLL";
export const IS_REDIRECTED = "IS_REDIRECTED";
export const IS_REFRESHED = "IS_REFRESHED";
